<div class="grid">
  <div class="padding">
    <h1>Impressum</h1>
    <p><b>Elektrotechnik Leutgeb GmbH</b></p>
    <p>
      Dauphinestraße 79a<br />4030 Linz<br />Tel.: 0043 (0) 664 / 52 43 714<br />Fax:
      0043 (0) 664 / 52 43 714<br />office@elektrotechnik-leutgeb.at
    </p>
    <p>
      UID: ATU69435756<br />Firmenbuchnummer: 431047v<br />Geschäftsführender
      Gesellschafter: Peter Leutgeb<br />Sitz des Firmenbuchgerichtes: Linz<br />Für
      den Inhalt verantwortlich: Leutgeb Peter
      (leutgeb@elektrotechnik-leutgeb.at)
    </p>
    <p>
      Die Elektrotechnik Leutgeb GmbH freut sich über Ihren Besuch auf unserer
      Website und Ihr Interesse an unseren Angeboten.
    </p>
    <p>
      Alle Rechte vorbehalten<br />Texte, Bilder, Grafiken, und Animationen
      sowie deren Anordnung auf der Elektrotechnik Leutgeb Homepage unterliegen
      dem Schutz des Urheberrechts. Der Inhalt dieser Websites darf nicht zu
      kommerziellen Zwecken kopiert, verbreitet, verändert oder Dritten
      zugänglich gemacht werden.
    </p>
    <p>
      Keine Garantie, Haftungsausschluss<br />Diese Website wurde mit
      größtmöglicher Sorgfalt zusammengestellt. Trotzdem kann Elektrotechnik
      Leutgeb für die Fehlerfreiheit, Vollständigkeit und Aktualität der
      enthaltenen Informationen nicht garantieren. Elektrotechnik Leutgeb
      schließt jegliche Haftung für Schäden, die direkt oder indirekt aus der
      Benutzung dieser Website entstehen, aus, soweit diese nicht auf Vorsatz
      oder grober Fahrlässigkeit von Elektrotechnik Leutgeb beruhen. Dies gilt
      auch für alle Verbindungen ("Links"), auf die diese Webseite direkt oder
      indirekt verweist.
    </p>
    <p>
      Datenschutz<br />Sämtliche auf der Website erhobenen persönlichen Daten
      werden ausschließlich zu Ihrer individuellen Betreuung oder der
      Unterbreitung von Angeboten gespeichert und verarbeitet. Elektrotechnik
      Leutgeb sichert zu, dass Ihre Angaben entsprechend den geltenden
      datenschutzrechtlichen Bestimmungen vertraulich behandelt werden.
    </p>
    <p>
      Informationen zur Online-Streitbeilegung:<br />Die EU-Kommission hat eine
      Internetplattform zur Online-Beilegung von Streitigkeiten (sog.
      „OS-Plattform“) geschaffen. Die OS-Plattform dient als Anlaufstelle zur
      außergerichtlichen Beilegung von Streitigkeiten betreffend vertragliche
      Verpflichtungen, die aus Online-Kaufverträgen erwachsen. Der Kunde kann
      die OS-Plattform unter dem folgenden Link erreichen:
      <a href="http://ec.europa.eu/consumers/odr/"
        >http://ec.europa.eu/consumers/odr/</a
      >
    </p>
    <p>
      <b>Website by Jonas Hiptmair</b><br /><a href="https://www.hiptmairit.at"
        >Website</a
      ><br /><a href="https://www.instagram.com/jonas.hiptmair.it/"
        >Instagram</a
      >
    </p>
  </div>
</div>
<div class="grid bg">
  <div>
    <h2>Erklärung zur Informationspflicht</h2>
    <p>
      Der Schutz Ihrer persönlichen Daten ist uns ein besonderes Anliegen. Wir
      verarbeiten Ihre Daten daher ausschließlich auf Grundlage der gesetzlichen
      Bestimmungen (DSGVO). In diesen Datenschutzinformationen informieren wir
      Sie über die wichtigsten Aspekte der Datenverarbeitung im Rahmen unserer
      Website.
    </p>
    <p>
      <b>Kontakt mit uns</b><br />Wenn Sie per Formular auf der Website oder per
      E-Mail Kontakt mit uns aufnehmen, werden Ihre angegebenen Daten zwecks
      Bearbeitung der Anfrage und für den Fall von Anschlussfragen sechs Monate
      bei uns gespeichert. Diese Daten geben wir nicht ohne Ihre Einwilligung
      weiter.
    </p>
    <p>
      Wenn Sie bereits geschäftlich mit uns in Verbindung gewesen sind, haben
      wir weiters folgende Daten von Ihnen gespeichert: Name, Telefonnummer,
      Adresse, E-Mail Adresse sowie weitere Daten zu Wartungszwecken. All diese
      Daten haben wir direkt von Ihnen erhalten.
    </p>
    <p>
      <b>Cookies</b><br />Unsere Website verwendet so genannte Cookies. Dabei
      handelt es sich um kleine Textdateien, die mit Hilfe des Browsers auf
      Ihrem Endgerät abgelegt werden. Sie richten keinen Schaden an. Diese
      werden erst durch den Klick auf „Cookies akzeptieren“ auf Ihr Gerät
      übertragen.
    </p>
    <p>
      Wir nutzen Cookies dazu, unser Angebot nutzerfreundlich zu gestalten.
      Einige Cookies bleiben auf Ihrem Endgerät gespeichert, bis Sie diese
      löschen. Sie ermöglichen es uns, Ihren Browser beim nächsten Besuch
      wiederzuerkennen.
    </p>
    <p>
      Wenn Sie dies nicht wünschen, so können Sie Ihren Browser so einrichten,
      dass er Sie über das Setzen von Cookies informiert und Sie dies nur im
      Einzelfall erlauben.
    </p>
    <p>
      Bei der Deaktivierung von Cookies kann die Funktionalität unserer Website
      eingeschränkt sein.
    </p>
    <p>
      <b>Web-Analyse</b><br />Unsere Website speichert automatisch Ihre aktuelle
      IP-Adresse und das aktuelle Datum. Diese Daten werden ausschließlich zur
      Besucherzählung verwendet.
    </p>
    <p>
      Die Datenverarbeitung erfolgt auf Basis der gesetzlichen Bestimmungen des
      § 96 Abs 3 TKG sowie des Art 6 Abs 1 lit a (Einwilligung) und/oder f
      (berechtigtes Interesse) der DSGVO.<br />
    </p>
    <p>
      Unser Anliegen im Sinne der DSGVO (berechtigtes Interesse) ist die
      Verbesserung unseres Angebotes und unseres Webauftritts. Da uns die
      Privatsphäre unserer Nutzer wichtig ist, werden die Nutzerdaten
      pseudonymisiert.
    </p>
    <p>
      Die Nutzerdaten werden bei uns für unbegrenzte Zeit gespeichert. Jedoch
      sind darin keine persönlichen Daten enthalten.
    </p>
    <p>
      <b>Ihre Rechte</b><br />Ihnen stehen grundsätzlich die Rechte auf
      Auskunft, Berichtigung, Löschung, Einschränkung, Datenübertragbarkeit,
      Widerruf und Widerspruch zu. Wenn Sie glauben, dass die Verarbeitung Ihrer
      Daten gegen das Datenschutzrecht verstößt oder Ihre datenschutzrechtlichen
      Ansprüche sonst in einer Weise verletzt worden sind, können Sie sich bei
      der Aufsichtsbehörde beschweren. In Österreich ist dies die
      Datenschutzbehörde.
    </p>
    <p>
      Sie erreichen uns unter folgenden Kontaktdaten:
      office@elektrotechnik-leutgeb.at
    </p>
  </div>
</div>
